export default __webpack_public_path__ + "static/media/chevron-up.67f61d59.svg";